export default {
	workspace_tabs_create_actions_split_view_label: 'Neu angelegte Objekte im Seitenpanel öffnen',
	workspace_tabs_position_bottom: 'Unten',
	workspace_tabs_position_label: 'Position der Tab-Leiste',
	workspace_tabs_position_top: 'Oben',
	workspace_tabs_records_split_view_label: 'Akten im Seitenpanel öffnen',
	workspace_tabs_responsive_exit_discard: 'Änderungen verwerfen und mobile Ansicht öffnen',
	workspace_tabs_responsive_exit_message:
		'Beim Wechsel in die mobile Ansicht gehen ungespeicherte Änderungen in offenen Tabs verloren.',
	workspace_tabs_responsive_exit_stay: 'In Tab-Ansicht bleiben',
	workspace_tabs_responsive_exit_title: 'Ungespeicherte Änderungen',
	workspace_tabs_save_and_close: 'Speichern und Tab schließen',
	workspace_tabs_scroll_back: 'Tabs nach links scrollen',
	workspace_tabs_scroll_forward: 'Tabs nach rechts scrollen',
	workspace_tabs_settings_warning_accept: 'Deaktivieren',
	workspace_tabs_settings_warning_message:
		'Beim Deaktivieren werden alle offenen Arbeitsbereich-Tabs geschlossen. Ungespeicherte Änderungen in offenen Tabs gehen verloren.',
	workspace_tabs_settings_warning_title: 'Tab-Arbeitsbereich deaktivieren?',
	workspace_tabs_title_PhoneBook: 'Telefonbuch',
	workspace_tabs_title_addon: 'Erweiterung',
	workspace_tabs_title_agendaList: 'Kalender',
	workspace_tabs_title_appointment: 'Termin',
	workspace_tabs_title_contact_history: 'Kontakthistorie',
	workspace_tabs_title_document: 'Dokument',
	workspace_tabs_title_documentList: 'Dokumente',
	workspace_tabs_title_filterList: 'Filter',
	workspace_tabs_title_inbox: 'Startseite',
	workspace_tabs_title_kanbanBoard: 'Kanban',
	workspace_tabs_title_mail: 'Mail',
	workspace_tabs_title_mailList: 'Mails',
	workspace_tabs_title_mailSend: 'Neue Mail',
	workspace_tabs_title_mailSendWithReceiver: 'Neue Mail',
	workspace_tabs_title_memo: 'Aktennotiz',
	workspace_tabs_title_message: 'Nachricht',
	workspace_tabs_title_messageList: 'Nachrichten',
	workspace_tabs_title_note: 'Merkzettel',
	workspace_tabs_title_noteList: 'Merkzettel',
	workspace_tabs_title_notebookList: 'Mappe',
	workspace_tabs_title_organization: 'Organisation',
	workspace_tabs_title_phoneCall: 'Anruf',
	workspace_tabs_title_phoneCallCreate: 'Neuer Anruf',
	workspace_tabs_title_phoneCallList: 'Anrufe',
	workspace_tabs_title_record: 'Akte',
	workspace_tabs_title_records: 'Akten',
	workspace_tabs_title_records_search: 'Suche',
	workspace_tabs_title_relationsHistory: 'Beziehungshistorie',
	workspace_tabs_title_settings: 'Einstellungen',
	workspace_tabs_title_task: 'Aufgabe',
	workspace_tabs_title_taskList: 'Aufgaben',
	workspace_tabs_title_timer: 'Timer',
	workspace_tabs_title_trashList: 'Papierkorb',
	workspace_tabs_title_userOnline: 'Benutzer online',
};
